import { produce } from "immer";
import { theme } from "../../theme/theme";
import { CLEAR_ALL_ERROR_MESSAGE, CLEAR_ERROR_MESSAGE, LOAD_API_DATA, SET_API_DATA, SET_ERROR_MESSAGE, SET_FORM_OPTION, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "./alert.type";
const INITAL_STATE = {
    apiData: {
        alertList: {
            status: "idle",
            data: [
                // {
                //     alert_id: 110234567,
                //     alert_type: 'Email',
                //     info: 'user0@example.com',
                //     status: 'Active'
                // },
                // {
                //     alert_id: 110234568,
                //     alert_type: 'Microsoft Teams',
                //     info: 'user1@example.com',
                //     status: 'Inactive'
                // },
                // {
                //     alert_id: 110234569,
                //     alert_type: 'Email',
                //     info: 'user2@example.com',
                //     status: 'Active'
                // },
                // {
                //     alert_id: 110234570,
                //     alert_type: 'Microsoft Teams',
                //     info: 'user3@example.com',
                //     status: 'Inactive'
                // },
                // {
                //     alert_id: 110234571,
                //     alert_type: 'Email',
                //     info: 'user4@example.com',
                //     status: 'Active'
                // },
                // {
                //     alert_id: 110234572,
                //     alert_type: 'Microsoft Teams',
                //     info: 'user5@example.com',
                //     status: 'Inactive'
                // },
                // {
                //     alert_id: 110234573,
                //     alert_type: 'Email',
                //     info: 'user6@example.com',
                //     status: 'Active'
                // },
                // {
                //     alert_id: 110234574,
                //     alert_type: 'Microsoft Teams',
                //     info: 'user7@example.com',
                //     status: 'Inactive'
                // },
                // {
                //     alert_id: 110234575,
                //     alert_type: 'Email',
                //     info: 'user8@example.com',
                //     status: 'Active'
                // },
                // {
                //     alert_id: 110234576,
                //     alert_type: 'Microsoft Teams',
                //     info: 'user9@example.com',
                //     status: 'Inactive'
                // }
            ],
            isError: false,
            errorMessage: "",
            loading: false
        },
        submitingAlert: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: "",
            loading: false
        },
        editingAlert: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: "",
            loading: false
        },
        deletingAlert: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: "",
            loading: false
        },
        
    },
    formData: {
        alert_type: {
            value: "Email",
            valueAsObj: {},
            options: ["Email", "Teams"],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        email: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        channel_name: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },

        weebhook_link: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        activateAlert: {
            value: true,
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        }

    }

}

const AlertReducer = (state = INITAL_STATE, { type, payload }) => {
    switch (type) {
        case SET_FORM_VALUE: {
            return produce(state, (draft) => {
                if (payload.formField === "alert_type" && typeof payload.value === "string") {
                    const options = ["Email", "Teams"]
                    const matched = options.find(
                      (opt) => opt.toLowerCase() === payload.value.toLowerCase()
                    );
                    draft.formData[payload.formField].value = matched || payload.value;
                  }
                  else{
                    draft.formData[payload.formField].value = payload.value
                  }
                
            });
        }
        case SET_FORM_VALUEOBJ: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].valueAsObj = payload.valueAsObj
            });
        }
        case SET_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = payload.isError
                draft.formData[payload.formField].errorMessage = payload.errorMessage
            });
        }
        case CLEAR_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = false
                draft.formData[payload.formField].errorMessage = ""
            });
        }
        case CLEAR_ALL_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                Object.keys(draft.formData).forEach((val) => {
                    draft.formData[val].isError = false
                    draft.formData[val].errorMessage = ""
                })

            });
        }
        case LOAD_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = true
                draft.apiData[payload.apiField].status = "loading"
            })
        case SET_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = false;
                draft.apiData[payload.apiField].status =
                    payload.status !== undefined && payload.status !== null
                        ? payload.status
                        : "success";
                draft.apiData[payload.apiField].data = payload.data;
            });
        case SET_FORM_OPTION:
            return produce(state, (draft) => {
                draft.formData[payload.formField].loading = false;
                draft.formData[payload.formField].options = payload.data;
            });
        // Return the current state if no action matches
        default:
            return state;
    }
}
export default AlertReducer;